import { css } from '../../../stitches.config.js';

const Col = css({
  boxSizing: 'border-box',
  width: '100%',
  variants: {
    col: {
      1: {
        gridColumnEnd: 'span 1'
      },
      2: {
        gridColumnEnd: 'span 2'
      },
      3: {
        gridColumnEnd: 'span 3'
      },
      4: {
        gridColumnEnd: 'span 4'
      },
      5: {
        gridColumnEnd: 'span 5'
      },
      6: {
        gridColumnEnd: 'span 6'
      },
      7: {
        gridColumnEnd: 'span 7'
      },
      8: {
        gridColumnEnd: 'span 8'
      },
      9: {
        gridColumnEnd: 'span 9'
      },
      10: {
        gridColumnEnd: 'span 10'
      },
      11: {
        gridColumnEnd: 'span 11'
      },
      12: {
        gridColumnEnd: 'span 12'
      }
    },
    start: {
      auto: {
        gridColumnStart: 'auto'
      },
      1: {
        gridColumnStart: '1'
      },
      2: {
        gridColumnStart: '2'
      },
      3: {
        gridColumnStart: '3'
      },
      4: {
        gridColumnStart: '4'
      },
      5: {
        gridColumnStart: '5'
      },
      6: {
        gridColumnStart: '6'
      },
      7: {
        gridColumnStart: '7'
      },
      8: {
        gridColumnStart: '8'
      },
      9: {
        gridColumnStart: '9'
      },
      10: {
        gridColumnStart: '10'
      },
      11: {
        gridColumnStart: '11'
      },
      12: {
        gridColumnStart: '12'
      }
    }
  },
  defaultVariants: {
    col: '1',
    start: 'auto'
  }
});

export { Col };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ29sLnN0eWxlcy5qcyIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vLi4vbGlicy9yZWFjdC1jb21wb25lbnRzL3NyYy9saWIvY29tcG9uZW50cy9ncmlkL0NvbC5zdHlsZXMudHN4Il0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNzcyB9IGZyb20gJy4uLy4uLy4uL3N0aXRjaGVzLmNvbmZpZydcblxuZXhwb3J0IGNvbnN0IENvbCA9IGNzcyh7XG4gIGJveFNpemluZzogJ2JvcmRlci1ib3gnLFxuICB3aWR0aDogJzEwMCUnLFxuXG4gIHZhcmlhbnRzOiB7XG4gICAgY29sOiB7XG4gICAgICAxOiB7XG4gICAgICAgIGdyaWRDb2x1bW5FbmQ6ICdzcGFuIDEnXG4gICAgICB9LFxuICAgICAgMjoge1xuICAgICAgICBncmlkQ29sdW1uRW5kOiAnc3BhbiAyJ1xuICAgICAgfSxcbiAgICAgIDM6IHtcbiAgICAgICAgZ3JpZENvbHVtbkVuZDogJ3NwYW4gMydcbiAgICAgIH0sXG4gICAgICA0OiB7XG4gICAgICAgIGdyaWRDb2x1bW5FbmQ6ICdzcGFuIDQnXG4gICAgICB9LFxuICAgICAgNToge1xuICAgICAgICBncmlkQ29sdW1uRW5kOiAnc3BhbiA1J1xuICAgICAgfSxcbiAgICAgIDY6IHtcbiAgICAgICAgZ3JpZENvbHVtbkVuZDogJ3NwYW4gNidcbiAgICAgIH0sXG4gICAgICA3OiB7XG4gICAgICAgIGdyaWRDb2x1bW5FbmQ6ICdzcGFuIDcnXG4gICAgICB9LFxuICAgICAgODoge1xuICAgICAgICBncmlkQ29sdW1uRW5kOiAnc3BhbiA4J1xuICAgICAgfSxcbiAgICAgIDk6IHtcbiAgICAgICAgZ3JpZENvbHVtbkVuZDogJ3NwYW4gOSdcbiAgICAgIH0sXG4gICAgICAxMDoge1xuICAgICAgICBncmlkQ29sdW1uRW5kOiAnc3BhbiAxMCdcbiAgICAgIH0sXG4gICAgICAxMToge1xuICAgICAgICBncmlkQ29sdW1uRW5kOiAnc3BhbiAxMSdcbiAgICAgIH0sXG4gICAgICAxMjoge1xuICAgICAgICBncmlkQ29sdW1uRW5kOiAnc3BhbiAxMidcbiAgICAgIH1cbiAgICB9LFxuXG4gICAgc3RhcnQ6IHtcbiAgICAgIGF1dG86IHtcbiAgICAgICAgZ3JpZENvbHVtblN0YXJ0OiAnYXV0bydcbiAgICAgIH0sXG4gICAgICAxOiB7XG4gICAgICAgIGdyaWRDb2x1bW5TdGFydDogJzEnXG4gICAgICB9LFxuICAgICAgMjoge1xuICAgICAgICBncmlkQ29sdW1uU3RhcnQ6ICcyJ1xuICAgICAgfSxcbiAgICAgIDM6IHtcbiAgICAgICAgZ3JpZENvbHVtblN0YXJ0OiAnMydcbiAgICAgIH0sXG4gICAgICA0OiB7XG4gICAgICAgIGdyaWRDb2x1bW5TdGFydDogJzQnXG4gICAgICB9LFxuICAgICAgNToge1xuICAgICAgICBncmlkQ29sdW1uU3RhcnQ6ICc1J1xuICAgICAgfSxcbiAgICAgIDY6IHtcbiAgICAgICAgZ3JpZENvbHVtblN0YXJ0OiAnNidcbiAgICAgIH0sXG4gICAgICA3OiB7XG4gICAgICAgIGdyaWRDb2x1bW5TdGFydDogJzcnXG4gICAgICB9LFxuICAgICAgODoge1xuICAgICAgICBncmlkQ29sdW1uU3RhcnQ6ICc4J1xuICAgICAgfSxcbiAgICAgIDk6IHtcbiAgICAgICAgZ3JpZENvbHVtblN0YXJ0OiAnOSdcbiAgICAgIH0sXG4gICAgICAxMDoge1xuICAgICAgICBncmlkQ29sdW1uU3RhcnQ6ICcxMCdcbiAgICAgIH0sXG4gICAgICAxMToge1xuICAgICAgICBncmlkQ29sdW1uU3RhcnQ6ICcxMSdcbiAgICAgIH0sXG4gICAgICAxMjoge1xuICAgICAgICBncmlkQ29sdW1uU3RhcnQ6ICcxMidcbiAgICAgIH1cbiAgICB9XG4gIH0sXG5cbiAgZGVmYXVsdFZhcmlhbnRzOiB7XG4gICAgY29sOiAnMScsXG4gICAgc3RhcnQ6ICdhdXRvJ1xuICB9XG59KVxuIl0sIm5hbWVzIjpbIkNvbCIsImNzcyIsImJveFNpemluZyIsIndpZHRoIiwidmFyaWFudHMiLCJjb2wiLCJncmlkQ29sdW1uRW5kIiwic3RhcnQiLCJhdXRvIiwiZ3JpZENvbHVtblN0YXJ0IiwiZGVmYXVsdFZhcmlhbnRzIl0sIm1hcHBpbmdzIjoiOztBQUVhQSxNQUFBQSxHQUFHLEdBQUdDLEdBQUcsQ0FBQztBQUNyQkMsRUFBQUEsU0FBUyxFQUFFLFlBQVk7QUFDdkJDLEVBQUFBLEtBQUssRUFBRSxNQUFNO0FBRWJDLEVBQUFBLFFBQVEsRUFBRTtBQUNSQyxJQUFBQSxHQUFHLEVBQUU7QUFDSCxNQUFBLENBQUMsRUFBRTtBQUNEQyxRQUFBQSxhQUFhLEVBQUUsUUFBQTtPQUNoQjtBQUNELE1BQUEsQ0FBQyxFQUFFO0FBQ0RBLFFBQUFBLGFBQWEsRUFBRSxRQUFBO09BQ2hCO0FBQ0QsTUFBQSxDQUFDLEVBQUU7QUFDREEsUUFBQUEsYUFBYSxFQUFFLFFBQUE7T0FDaEI7QUFDRCxNQUFBLENBQUMsRUFBRTtBQUNEQSxRQUFBQSxhQUFhLEVBQUUsUUFBQTtPQUNoQjtBQUNELE1BQUEsQ0FBQyxFQUFFO0FBQ0RBLFFBQUFBLGFBQWEsRUFBRSxRQUFBO09BQ2hCO0FBQ0QsTUFBQSxDQUFDLEVBQUU7QUFDREEsUUFBQUEsYUFBYSxFQUFFLFFBQUE7T0FDaEI7QUFDRCxNQUFBLENBQUMsRUFBRTtBQUNEQSxRQUFBQSxhQUFhLEVBQUUsUUFBQTtPQUNoQjtBQUNELE1BQUEsQ0FBQyxFQUFFO0FBQ0RBLFFBQUFBLGFBQWEsRUFBRSxRQUFBO09BQ2hCO0FBQ0QsTUFBQSxDQUFDLEVBQUU7QUFDREEsUUFBQUEsYUFBYSxFQUFFLFFBQUE7T0FDaEI7QUFDRCxNQUFBLEVBQUUsRUFBRTtBQUNGQSxRQUFBQSxhQUFhLEVBQUUsU0FBQTtPQUNoQjtBQUNELE1BQUEsRUFBRSxFQUFFO0FBQ0ZBLFFBQUFBLGFBQWEsRUFBRSxTQUFBO09BQ2hCO0FBQ0QsTUFBQSxFQUFFLEVBQUU7QUFDRkEsUUFBQUEsYUFBYSxFQUFFLFNBQUE7QUFDaEIsT0FBQTtLQUNGO0FBRURDLElBQUFBLEtBQUssRUFBRTtBQUNMQyxNQUFBQSxJQUFJLEVBQUU7QUFDSkMsUUFBQUEsZUFBZSxFQUFFLE1BQUE7T0FDbEI7QUFDRCxNQUFBLENBQUMsRUFBRTtBQUNEQSxRQUFBQSxlQUFlLEVBQUUsR0FBQTtPQUNsQjtBQUNELE1BQUEsQ0FBQyxFQUFFO0FBQ0RBLFFBQUFBLGVBQWUsRUFBRSxHQUFBO09BQ2xCO0FBQ0QsTUFBQSxDQUFDLEVBQUU7QUFDREEsUUFBQUEsZUFBZSxFQUFFLEdBQUE7T0FDbEI7QUFDRCxNQUFBLENBQUMsRUFBRTtBQUNEQSxRQUFBQSxlQUFlLEVBQUUsR0FBQTtPQUNsQjtBQUNELE1BQUEsQ0FBQyxFQUFFO0FBQ0RBLFFBQUFBLGVBQWUsRUFBRSxHQUFBO09BQ2xCO0FBQ0QsTUFBQSxDQUFDLEVBQUU7QUFDREEsUUFBQUEsZUFBZSxFQUFFLEdBQUE7T0FDbEI7QUFDRCxNQUFBLENBQUMsRUFBRTtBQUNEQSxRQUFBQSxlQUFlLEVBQUUsR0FBQTtPQUNsQjtBQUNELE1BQUEsQ0FBQyxFQUFFO0FBQ0RBLFFBQUFBLGVBQWUsRUFBRSxHQUFBO09BQ2xCO0FBQ0QsTUFBQSxDQUFDLEVBQUU7QUFDREEsUUFBQUEsZUFBZSxFQUFFLEdBQUE7T0FDbEI7QUFDRCxNQUFBLEVBQUUsRUFBRTtBQUNGQSxRQUFBQSxlQUFlLEVBQUUsSUFBQTtPQUNsQjtBQUNELE1BQUEsRUFBRSxFQUFFO0FBQ0ZBLFFBQUFBLGVBQWUsRUFBRSxJQUFBO09BQ2xCO0FBQ0QsTUFBQSxFQUFFLEVBQUU7QUFDRkEsUUFBQUEsZUFBZSxFQUFFLElBQUE7QUFDbEIsT0FBQTtBQUNGLEtBQUE7R0FDRjtBQUVEQyxFQUFBQSxlQUFlLEVBQUU7QUFDZkwsSUFBQUEsR0FBRyxFQUFFLEdBQUc7QUFDUkUsSUFBQUEsS0FBSyxFQUFFLE1BQUE7QUFDUixHQUFBO0FBQ0YsQ0FBQTs7OzsifQ==
